<template>
  <div :class="['input-group', { 'not-allowed' : disabled }]">
    <span :class="{required: isRequired && label, optional: isOptional}">{{ label }}</span>
    <div
      v-if="desc"
      class="input-group__desc"
    >
      {{ desc }}
    </div>
    <div class="input-group__wrapper">
      <div
        class="input-group__wrapper__chips"
      >
        <div
          v-for="v in tempValue"
          :key="v"
          class="input-group__wrapper__chips__chip"
        >
          <div class="input-group__wrapper__chips__chip__text">
            {{ v }}
          </div>
          <div class="input-group__wrapper__chips__chip__image">
            <img
              :src="Close"
              alt="close.png"
              class="input-group__wrapper__chips__chip__image__img"
              @click="removeValue(v)"
            >
          </div>
        </div>
      </div>
      <input
        :id="id"
        v-model="textInput"
        :class="tempValue.length === maxItem ? 'hide-input' : ''"
        type="text"
        :name="name"
        :placeholder="tempValue.length ? '' : placeholder"
        tabindex="0"
        autocomplete="off"
        :disabled="disabled"
        @keypress.enter="addValue"
      >
    </div>
    <div class="input-group__note">
      <div class="input-group__note__number">
        {{ tempValue.length }}
      </div>
      <div class="input-group__note__text">
        ditambahkan
      </div>
    </div>
  </div>
</template>
<script>
import Close from "@/assets/close_modal.svg";

export default {
  props: {
    placeholder: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    isRequired: {
      type: Boolean,
    },
    label: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
    isOptional: {
      type: Boolean,
    },
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxItem: {
      type: Number,
      default: 5,
    }
  },
  data() {
    return {
      Close,
      tempValue: [],
      textInput: '',
    }
  },
  methods: {
    onInput(val) {
      this.$emit('input', val)
    },
    onClick(val) {
      this.$emit('click', val)
    },
    addValue(val) {
      let arrVal = val.target.value.split(/,|\.|;| /).filter(v => v)
      for (let i = 0; i < arrVal.length; i++) {
        if (this.tempValue.length < this.maxItem && !this.tempValue.includes(arrVal[i])) this.tempValue.push(arrVal[i])
        this.textInput = ''
        if (this.tempValue.length === this.maxItem) {
          document.querySelector('.input-group__wrapper__chips').classList.add('marginBottom8px')
        }
        this.$emit('update:modelValue', [...this.tempValue])
      }
    },
    removeValue(val) {
      this.tempValue = this.tempValue.filter((item) => item !== val)
      document.querySelector('.input-group__wrapper__chips').classList.remove('marginBottom8px')
      this.$emit('update:modelValue', [...this.tempValue])
    }
  },
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/style.scss";

.input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;

  span {
    font-size: 16px;
    line-height: 21px;
    color: $color-indigo-dark;
    font-weight: 600;

    @include for-size(mobile) {
      font-size: 14px;
    }

    &.required {
      &::after {
        content: "*";
        color: $color-red-5;
        margin-left: 4px;
      }
    }

    &.optional {
      &::after {
        content: "(Opsional)";
        color: $color-gray-shade;
        margin-left: 4px;
        font-weight: 400;
      }
    }
  }

  &__desc {
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: $color-text-small;

    @include for-size(mobile) {
      font-size: 10px;
    }
  }

  &__wrapper {
    border-bottom: 1px solid $color-border-primary;

    &__chips {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      max-height: 250px;
      overflow-y: scroll;

      @include for-size(mobile) {
        gap: 8px;
      }

      &__chip {
        display: flex;
        justify-content: center;
        align-items: center;
        width: max-content;
        height: 40px;
        padding: 0 8px;
        background-color: #F2F4F7;
        border-radius: 250px;

        @include for-size(mobile) {
          margin-right: unset;
          padding: 0 16px;

          &:not(:last-of-type) {
            margin-bottom: 4px;
          }
        }

        &__text {
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
          color: $color-indigo-dark;
        }

        &__image {
          width: max-content;

          &__img {
            margin-left: 5px;
            width: 9.33px;
            height: 9.33px;
            filter: invert(0.6);
            cursor: pointer;
          }
        }
      }
    }
  }

  &__note {
    display: flex;
    font-size: 14px;
    line-height: 21px;
    font-weight: 400;

    @include for-size(mobile) {
      font-size: 12px;
    }
    
    &__number {
      color: $color-indigo-dark;
      font-weight: 600;
      margin-right: 4px;
    }

    &__text {
      color: $color-gray-shade;
      font-weight: 400;
    }
  }

  input {
    width: 100%;
    border: none;
    padding: 0;
    height: 50px;
  }

  input:focus {
    outline: none;
  }

  input[type="text"]::placeholder {
    color: $color-gray-shade;
    font-size: 14px!important;
  }

  .hide-input {
    display: none;
  }
}

.not-allowed {
  cursor: not-allowed;

  input {
    background-color: transparent !important;
    opacity: 0.5;
  }
}

.marginBottom8px {
  margin-bottom: 8px;
}
</style>
